import React from "react";
import { Col } from "reactstrap";
import { DebounceInput } from "react-debounce-input";
import { useSpecificationContextState } from "./useSpecificationContextState";
import _ from "lodash";

export default function NumberFormatCalculated({ onChangeString }) {
  const SpecContextState = useSpecificationContextState();
  let defense = parseFloat(SpecContextState.specification[onChangeString]);
  let value = defense;
  if(_.isNaN(defense)) {
    value = SpecContextState.specification[onChangeString];
  } else {
    value = defense.toFixed(2);
  }

  return (
    <Col xs="2">
      <DebounceInput
        key={onChangeString}
        element={"input"}
        className={"form-control"}
        value={!value ? "N/A" : value}
        // onChange={(e) => onChangeRegexFormat(e.target.value, onChangeString)}
        // debounceTimeout={350}
        // placeholder={"N/A"}
        readOnly={true}
        disabled={true}
      />
    </Col>
  );
}
